import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";

import moment from "moment";

import { Dropdown, Button, Menu, Modal, Tag } from "antd";

import {
	UIAvatarLabel,
	UIPageListing,
} from "../../../components";

import { employeesService } from "../../../redux/services";

import ModalEdit from "./edit";
import ModalCreate from "./create";
import ModalFilters from "../../Departments/filters";

const config = {
	searchPlaceholder: "Buscar funcionário",
	permissionPrefix: "customers",
};

const OWNERS = {
	empresa     : { contractKey: "empresa_id", params: (owner) => ({ empresa_id: owner.id }) },
	departamento: { contractKey: "departamento_id", params: (owner) => ({ departamento_uuid: owner.uuid }) },
	funcao      : { contractKey: "funcao_id", params: (owner) => ({ funcao_uuid: owner.uuid }) },
};

class Index extends Component {
	static propTypes = {
		filterBy: PropTypes.oneOf(Object.keys(OWNERS)),
	};

	static defaultProps = {
		filterBy: "empresa",
	};

	constructor(props) {
		super(props);

		this.state = {
			listType: "list",
			isLoading: false,
			dataAll: [],
			data: [],
			search: '',
			// Owner item
			ownerItem: {},
			// Actions
			editModalVisible: false,
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
			},
			filtersModalVisible: false,
			filters: {
				is_active: 1,
			},
		};
	}

	init = (ownerItem) => {
		this.setState({
			ownerItem: ownerItem,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({ uuid }) => {
		this.setState({ editModalVisible: true });

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({ uuid }) => {
		Modal.confirm({
			title: "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText: "Excluir",
			autoFocusButton: null,
			onOk: () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return employeesService.destroy(this.state.ownerItem.uuid, uuid)
			.then((response) => {
				// Fecth all
				this.fetchGetAll();
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	editOnComplete = () => {
		this.setState({ editModalVisible: false });

		// Fecth all
		this.fetchGetAll();
	};

	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{/* {this.props.permissions.includes(config.permissionPrefix + ".edit") &&  */}
			<Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>
			{/* } */}
			{/* {this.props.permissions.includes(config.permissionPrefix + ".delete") &&  */}
			<Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>
			{/* } */}
		</Menu>
	);

	getContract = (item) => {
		const { ownerItem } = this.state;
		const key = OWNERS[this.props.filterBy].contractKey;

		return item.contrato?.find((contrato) => contrato[key] === ownerItem.id) ?? item.contrato?.[0];
	};

	columns = () => {
		const { filterBy } = this.props;
		const byCompany = filterBy === "empresa";

		return [
			{
				title: "Nome",
				// width: 150
				render: (item) => <UIAvatarLabel id={item?.id} name={item?.nome} avatar={item?.avatar} />,
			},
			{
				title: "Nº da folha",
				width: 120,
				visible: !byCompany,
				render: (item) => item.numero_folha ?? "-",
			},
			{
				title: "Empresa",
				visible: filterBy === "funcao",
				render: (item) => this.getContract(item)?.empresa?.nome ?? "-",
			},
			{
				title: "Departamento",
				visible: filterBy !== "departamento",
				// width: 150
				render: (item) => this.getContract(item)?.departamento?.nome ?? "-",
			},
			{
				title: "Função",
				visible: filterBy !== "funcao",
				// width: 150
				render: (item) => this.getContract(item)?.funcoes?.nome ?? "-",
			},
			{
				title: "Status",
				className: "active no-ellipsis",
				width: 90,
				visible: !byCompany,
				render: (item) => (
					<span className={`status-tag ${item.ativo == 1 ? "status-tag-success" : "status-tag-error"}`}>
						<i className="status-tag-dot" />
						{item.ativo == 1 ? "Ativo" : "Inativo"}
					</span>
				),
			},
		];
	};

	fetchGetAll = (init = false) => {
		const { pagination, ownerItem, filters } = this.state;
		const { filterBy } = this.props;

		this.setState({
			isLoading: true,
		});

		const data = {
			// orderBy: `${orderByField}:${orderBySort}`,
			search: this.state.search,
			...OWNERS[filterBy].params(ownerItem),
			page: init ? 1 : pagination.current,
			limit: pagination.pageSize,
		};

		if (filterBy !== "empresa" && filters.is_active !== null) {
			data.is_active = filters.is_active;
		}

		employeesService.getAll(data)
			.then((response) => {
				this.setState(state => ({
					isLoading: false,
					data: response.data.data,
					dataAll: response.data.data,
					pagination: {
						...state.pagination,
						current: response.data.meta.current_page,
						total: response.data.meta.total,
					},
				}));
			})
			.catch((data) => {
				this.setState({
					isLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(
			(state) => ({
				pagination: {
					...state.pagination,
					current: page,
					pageSize,
				},
			}),
			() => {
				this.fetchGetAll();
			}
		);
	};

	searchItems = () => {
		const { search } = this.state;
		const newData = [...this.state.dataAll];

		this.setState({
			data: search ? newData.filter((item) => item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1 || item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1) : newData,
		});
	};

	editOnClose = () => {
		this.setState({ editModalVisible: false });
	};
	filtersOpen = () => {
		this.setState({ filtersModalVisible: true });

		this.filtersScreen.onOpen({ ...this.state.filters });
	};

	filtersOnClose = () => {
		this.setState({ filtersModalVisible: false });
	};

	filtersOnComplete = (filters) => {
		this.setState({
			filtersModalVisible: false,
			filters: filters,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if (!e.hasOwnProperty("type")) {
			const { search } = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if (search) {
					this.searchItems();
				}
			});
		}
	};


	render() {
		const withStatusFilter = this.props.filterBy !== "empresa";

		return (
			<Fragment>
				<UIPageListing
					onSearch={this.onSearch}
					onSearchChange={this.onSearchChange}
					listType={this.state.listType}
					search={this.state.search}
					searchPlaceholder={config.searchPlaceholder}
					showListTypeChange={false}
					isLoading={this.state.isLoading}
					data={this.state.data}
					columns={this.columns()}
					pagination={this.state.pagination}
					onPaginationChange={this.onPaginationChange}
					showFilters={withStatusFilter}
					onFiltersClick={this.filtersOpen}
					buttons={[
						// {
						// 	visible: true,
						// 	// visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
						// 	onClick: this.createOpen,
						// 	title: "Incluir",
						// 	icon: <i className="far fa-plus" />,
						// },
					]}
				/>
				{withStatusFilter && (
					<ModalFilters
						ref={el => this.filtersScreen = el}
						visible={this.state.filtersModalVisible}
						onComplete={this.filtersOnComplete}
						onClose={this.filtersOnClose}
					/>
				)}
				{/* <ModalEdit
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalCreate
					client_uuid={this.state.ownerItem.uuid}
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/> */}
			</Fragment>
		)
	}
}

export default Index;
